
    $(".faqs").each(function () {
        $(this).find(".tabs .tab:first-of-type .tab__content").slideDown();
        $(this).find(".tabs .tab:first-of-type i").removeClass("fas fa-chevron-down").addClass("fas fa-chevron-up");
    })


$(".tab__heading").click(function (e) {

    if ($(this).parent().find(".tab__content").is(":hidden")) {
        $(this).parent().find(".tab__content").slideDown("slow");

        // $('html, body').animate({
        //   scrollTop: $(this).parent().offset().top - 120
        // }, 300);

        $(this).parent().find("i").toggleClass("fas fa-chevron-down").toggleClass("fas fa-chevron-up");
    } else {
        $(this).parent().find(".tab__content").slideUp("slow");
        $(this).parent().find("i").toggleClass("fas fa-chevron-up").toggleClass("fas fa-chevron-down");
    }

})
